import React, { useState,useEffect } from "react";
import {  useNavigate, useParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import { checkTime } from "../constant/constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDiceD20, faDiceOne, faDiceSix, faDiceThree, faDiceTwo } from "@fortawesome/free-solid-svg-icons";
import { useT } from "../i18n";
const MyComponent = () => {
    const { gameName } = useParams(); // Access the dynamic parameter
    const {all_games}=useSelector((state)=>state.users);
    const [Gametypes,setGametypes]=useState([]);
    const navigate=useNavigate();
    const { t } = useT();
    useEffect(()=>{
      let validate=false;
      all_games?.forEach((value)=>{
          if(value?.games_name.split(' ').join('_') === gameName){
              validate=checkTime(value?.open_time);
          }
      })
      if(!validate){
        let data=[
          { href: `/game_type_single/${gameName}/single_digit`, title: "Single Digit",color:'#007bff',icon:faDiceOne},
          { href: `/game_type/${gameName}/single_digit`, title: "Single Digit Bulk",color:'rgb(36, 113, 253)',icon:faDiceOne},
          { href: `/game_type_single/${gameName}/single_pana`, title: "Single Pana",color:'rgb(21, 198, 45)',icon:faDiceOne},
          { href: `/game_type/${gameName}/single_pana`, title: "Single Pana Bulk",color:'rgb(6, 177, 220)',icon:faDiceOne},
          { href: `/game_type_single/${gameName}/double_pana`, title: "Double Pana",color:'rgb(132, 25, 215)',icon:faDiceTwo},
          { href: `/game_type/${gameName}/double_pana`, title: "Double Pana Bulk",color:'rgb(54, 85, 252)',icon:faDiceTwo},
          { href: `/game_type_single/${gameName}/triple_pana`, title: "Triple Pana",color:'rgb(254, 118, 0)',icon:faDiceThree},
          // { href: `/game_type/${gameName}/triple_pana`, title: "Triple Pana Bulk",color:'#1ae31a',icon:faDiceOne},
        ]
        setGametypes(data);
      }else{
      let data=[
        { href: `/game_type_single/${gameName}/single_digit`, title: "Single Digit",color:'#007bff',icon:faDiceOne},
        { href: `/game_type/${gameName}/single_digit`, title: "Single Digit Bulk",color:'rgb(36, 113, 253)',icon:faDiceOne},
        { href: `/game_type_single/${gameName}/jodi_digit`, title: "Jodi Digit",color:'rgb(36, 113, 253)',icon:faDiceTwo},
        { href: `/game_type/${gameName}/jodi_digit`, title: "Jodi Digit Bulk",color:'rgb(162, 1, 179)',icon:faDiceTwo},
        { href: `/game_type_single/${gameName}/single_pana`, title: "Single Pana",color:'rgb(21, 198, 45)',icon:faDiceOne},
        { href: `/game_type/${gameName}/single_pana`, title: "Single Pana Bulk",color:'rgb(6, 177, 220)',icon:faDiceOne},
        { href: `/game_type_single/${gameName}/double_pana`, title: "Double Pana",color:'rgb(132, 25, 215)',icon:faDiceTwo},
        { href: `/game_type/${gameName}/double_pana`, title: "Double Pana Bulk",color:'rgb(54, 85, 252)',icon:faDiceTwo},
        { href: `/game_type_single/${gameName}/triple_pana`, title: "Triple Pana",color:'rgb(254, 118, 0)',icon:faDiceThree},
        { href: `/game_type/${gameName}/triple_pana`, title: "Triple Pana Bulk",color:'rgb(10, 176, 214)',icon:faDiceThree},
        { href: `/game_type/${gameName}/half_sangam`, title: "Half Sangam",color:'rgb(134, 191, 0)',icon:faDiceD20},
        { href: `/game_type/${gameName}/full_sangam`, title: "Full Sangam",color:'rgb(1, 177, 177)',icon:faDiceSix},
      ]
      setGametypes(data);

      }
  },[all_games,gameName]);


  return (
    <div className="gt-screen">
      <div className="gt-head">
        <h2>{gameName?.split('_').join(' ')}</h2>
        <p>{t('Select a game type to play')}</p>
      </div>
      <div className="gt-grid">
        {Gametypes.map((item) => (
          <button type="button" className="gt-card" key={item.href} onClick={()=>navigate(item.href)}>
            <span className="gt-icon"><FontAwesomeIcon icon={item.icon} /></span>
            <span className="gt-title">{t(item.title)}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MyComponent;
